import { render, staticRenderFns } from "./CInview.vue?vue&type=template&id=7fded456&"
import script from "./CInview.vue?vue&type=script&lang=ts&"
export * from "./CInview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports